import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=fcbf7b3a&scoped=true&"
var script = {}
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=fcbf7b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbf7b3a",
  null
  
)

export default component.exports